import { Button } from '@execonline-inc/execonline-ui';
import { OpenableAction } from '@execonline-inc/execonline-ui/dist/hooks/useOpenable/Types';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';
import ModalContent from './ModalContent';
import {
  PublishCelebration,
  SaveCelebration,
} from '../LearningCollection/ChatbotPreview/LearningCollectionPreviewStore/Types';
import { useNavigate } from 'react-router-dom';

interface Props {
  state: PublishCelebration | SaveCelebration;
  onClose: OpenableAction;
}

function LearningCollectionModal({ state, onClose }: Props) {
  const navigate = useNavigate();

  const handleDone = () => {
    sessionStorage.setItem('learningCollectionState', 'created');
    navigate('/learning_collections');
  };

  const handleInviteParticipants = () => {
    sessionStorage.setItem('learningCollectionState', 'published');
    onClose();
  };

  switch (state.kind) {
    case 'save-celebration':
      return (
        <ModalContent
          title="Collection Created"
          desc="Your collection has been created but is not published. You may now preview the unpublished collection with other admins, or publish the collection to invite participants"
        >
          <Button
            color="green"
            onClick={handleDone}
            data-intercom-target="collection-created-done-button"
          >
            <T kind="Done" />
          </Button>
        </ModalContent>
      );
    case 'publish-celebration':
      return (
        <ModalContent
          title="Publish Collection"
          desc="Your collection has been published and active. You may now invite participants."
        >
          <Button
            className="mb-4"
            color="green"
            onClick={handleInviteParticipants}
            data-intercom-target="invite-participants-button"
          >
            <T kind="Invite Participants" />
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => {
              sessionStorage.setItem('learningCollectionState', 'published');
              navigate('/learning_collections');
            }}
          >
            <T kind="Done" />
          </Button>
        </ModalContent>
      );
  }
}

export default observer(LearningCollectionModal);
